/**
 * Audit 0.36 F10: „Teilen“ klärt zuerst die Absicht. Wer jemanden ins Projekt holen oder als Gast einladen will, landet
 * in „Personen“ – von überall, auch aus einer Aufgabe heraus (Ereignis, das `ProjectPage` öffnet). Klein und statisch
 * ladbar: kein Dialog-Code im Startpaket.
 */
export interface PeopleRequest {
  projectId: string;
  /** Abschnitt in „Personen“, der vorne stehen soll */
  focus: 'members' | 'guests';
  /** Gast für genau diese Aufgabe einladen (Vorauswahl der Freigabe) */
  guestTask?: { id: string; title: string };
}
export const PEOPLE_EVENT = 'werft:people';
export const openPeople = (r: PeopleRequest) => window.dispatchEvent(new CustomEvent<PeopleRequest>(PEOPLE_EVENT, { detail: r }));
